import {constants as kandyConstants} from 'kandy-redux'
import {isFSA} from 'flux-standard-action'
import {messageEvent} from '../socketEvents'
import {chatActions,dashboardActions,serviceRequestActions,currentCallActions} from '../actions'
import * as types  from '../constants/ActionTypes'

import StateTypes from  '../constants/StateTypes'

const userInfoType = StateTypes.app.customers.userInfo;
import _ from 'lodash'
let middleware = ({dispatch, getState}) => {
	return next => action => {
		if (isFSA(action)) {
			if (
				action.type === kandyConstants.MESSAGE_RECEIVED ||
				action.type === kandyConstants.MESSAGE_IMAGE_RECEIVED ||
				action.type === kandyConstants.MESSAGE_AUDIO_RECEIVED ||
				action.type === kandyConstants.MESSAGE_VIDEO_RECEIVED ||
				action.type === kandyConstants.MESSAGE_FILE_RECEIVED
			) {
				var message = action.payload.message
				message.timestamp = action.payload.message.timestamp || Date.now()

				let appState = getState().app
				let agent = appState.currentAgent.userInfo
				let customer = appState.customers.current.filter(customer => customer.userId === message.sender.full_user_id)[0]
				let senderAgent = appState.agents.list.filter(agentObj => agentObj.fullUserId === message.sender.full_user_id)[0]
				let companyId=getState().company.id
				if (customer && customer._id !== appState.selectedCustomer)
					dispatch(chatActions.setUnreadCount(customer._id))

				if ((!appState.dashboard.showChatPanel) && senderAgent)
					dispatch(chatActions.setDashboardChatCount())

				if (senderAgent && (senderAgent.fullUserId !== appState.dashboard.selectedAgent)) {
					dispatch(chatActions.setAgentChatCount(senderAgent.fullUserId))
					dispatch(chatActions.setDepartmentAgentChatCount(senderAgent.fullUserId))
				}


                if (customer && agent) {
                    let receiver = {fullUserId: agent.fullUserId, name: agent.firstName}
                    let sender = {fullUserId: customer.userId, name: customer.userInfo.name}
                    messageEvent(companyId, customer._id, customer.userInfo.customerId, customer.userInfo.email, sender, receiver, message)
                }
            } else if (
                action.type === kandyConstants.SEND_MESSAGE_FINISH ||
                action.type === kandyConstants.SEND_IMAGE_MESSAGE_FINISH ||
                action.type === kandyConstants.SEND_AUDIO_MESSAGE_FINISH ||
                action.type === kandyConstants.SEND_VIDEO_MESSAGE_FINISH ||
                action.type === kandyConstants.SEND_FILE_MESSAGE_FINISH
            ) {
                var message = action.payload.message
                if (typeof message == 'object') {
                    message.timestamp = action.payload.message.timestamp || Date.now()

                    let appState = getState().app
                    let agent = appState.currentAgent.userInfo
                    let customer = appState.customers.current.filter(customer => customer.userId === message.destination)[0]
					let companyId = getState().company.id
                    // if email undefined :not saved
                    if (customer && agent) {

					    let receiver = {fullUserId: customer.userId, name: customer.userInfo.name}
					    let sender = {fullUserId: agent.fullUserId, name: agent.firstName}
					    messageEvent(companyId, customer._id, customer.userInfo.customerId, customer.userInfo.email, sender, receiver, message)
				    }
                }
			}
			else if (action.type === types.END_SESSION) {
				//��ȡ��ʷ��Ϣ
				dispatch(dashboardActions.isOrNoUserInfo(userInfoType.noneUserInfo))
				dispatch(serviceRequestActions.changeActiveCustomer(''))
				let appState = getState().app;
				let companyId = getState().company.id;
				let current = appState.customers.current;
				let currentCustomerArr = _.filter(current, (item) => item.userId === action.payload.userId);
				if (currentCustomerArr.length > 0) {
					let customerObj = currentCustomerArr[0];
					if (customerObj.userInfo.hasOwnProperty("email")) {

						dispatch(chatActions.getChatHistory(customerObj.userInfo.email, companyId));
					}
				}
			}
			else if(action.type === types.CURRENT_CALL_STATUS){
				//dispatch(currentCallActions.showFullScreen('close'))
				//if (document.exitFullscreen) {
				//	document.exitFullscreen();
				//}
				//else if (document.msExitFullscreen) {
				//	document.msExitFullscreen();
				//}
				//else if (document.mozCancelFullScreen) {
				//	document.mozCancelFullScreen();
				//}
				//else if (document.webkitCancelFullScreen) {
				//	document.webkitCancelFullScreen();
				//}
			}
		}
		return next(action)
	}
}

export default middleware
